jQuery(document).ready(function($) {
    $('.testimonial-slide ul').slick({
        dots: true,
	      arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        //autoplay: true,
        autoplaySpeed: 2000,

        responsive: [
            {
            breakpoint: 1081,
            settings: {
            slidesToShow: 2
             }
        },
            {
    
            breakpoint: 681,
    
            settings: {
    
              slidesToShow: 1
    
            }
    
          }
    
        ]
       
  }); 
});


jQuery(document).ready(function($) {
  $('.content-slider ul').slick({
      dots: true,
     arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,

}); 
});

jQuery(document).ready(function(){ jQuery(window).scroll(function() { var scroll = jQuery(window).scrollTop(); if (scroll >= 50) { jQuery(".pa-header").addClass("pa-fixed-header"); } else{ jQuery(".pa-header").removeClass("pa-fixed-header"); } }); }); 